<div class="measurements-panel">
  <div class="measurements-summary">
    <span>Resultado general: </span>
    <span class="summary-chip" [ngClass]="veredict ? 'is-success' : 'is-danger'">
      {{ veredict ? 'Aprobado' : 'Desaprobado' }}
    </span>
  </div>
  <mat-divider></mat-divider>
  <div class="measurements-list">
    <div *ngFor="let detail of rules; let i = index" class="measurements-item">
      <mat-icon
        class="material-symbols-outlined measurements-icon"
        [ngClass]="detail.approved ? 'is-success' : 'is-danger'"
      >
        {{ detail.approved ? 'check_circle' : 'cancel' }}
      </mat-icon>
      <div class="measurements-content">
        <div class="measurements-header">
          <span class="measurements-meta">REGLA: {{detail.rule_id}}</span>
          <span class="measurements-status" [ngClass]="detail.approved ? 'is-success' : 'is-danger'">
            {{ detail.approved ? 'Cumple' : 'No cumple' }}
          </span>
        </div>
        <span class="measurements-rule">{{detail.rule}}</span>
        <!-- <span class="measurements-rule-description">{{detail.rule_description}}</span> -->
      </div>
      <mat-divider></mat-divider>
    </div>
  </div>
</div>
